import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';
import { Text15Bold, Text15Regular, Text26ExtraBold } from '../../../components/utils/Text/Text.styles';

export const StyledButton = styled(Button)`
  margin-top: 2.5rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 500px) {
    flex: unset;
  }
`;

export const InvitationCodeWrapper = styled.div`
  border-radius: 15px;
  background: linear-gradient(93deg, #d8eaf9 1.58%, #badaf7 100%);
  padding: 1.6rem 1.2rem 0 1.2rem;
  width: 100%;
  margin-bottom: 2.1rem;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1.6rem;
  justify-content: center;

  @media only screen and (max-width: 500px) {
    margin-bottom: 5.8rem;
  }
`;

export const LinkText = styled(Text15Bold)`
  text-decoration-line: underline;
  color: #1672ba;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.4rem;
  flex: 1;
`;

export const Title = styled(Text26ExtraBold)`
  text-align: center;
`;

export const Subtitle = styled(Text15Regular)`
  line-height: 2.2rem;
  text-align: center;
  padding-inline: 2rem;
`;

export const ReviewTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
